
import React from 'react';

import PropTypes from 'prop-types';

// Material UI Imports
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';

// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// Material Icons Imports
import IconArchive from '@material-ui/icons/ArchiveOutlined';
import Iconedit from '@material-ui/icons/EditOutlined';

import Button from '@material-ui/core/Button';
import _ from 'lodash';
//Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import { Link } from 'react-router-dom';


const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: 0,
    position: 'relative',

  },
  fabProgress: {
    position: 'absolute',
    top: 5,
    left: 5,
    zIndex: 0,
  },
})

class CertificationsTableActions extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  _handleArchive = async (certification, handler) => {
    const certificationId = certification.id;

    await this.props.mutationMarkAsDeleted({
      variables: {
        certificationId
      }
    })
      .catch((e) => {
        console.log(e)
      })
      .then(this.handleClose)
      .then(handler)
  }

  render() {
    const { archiving } = this.state;
    const { classes, certification, handler } = this.props;

    return (
      <div className={classes.root}>
        <Tooltip title="Edit">
          <div className={classes.wrapper}>
            <Link to={`/certifications/${certification.id}/edit`}>
              <IconButton>
                <Iconedit />
              </IconButton>
            </Link>
          </div>
        </Tooltip>
        <Tooltip title="Archive">
          <div className={classes.wrapper}>
            <IconButton onClick={this.handleClickOpen}>
              <IconArchive />
            </IconButton>
            {archiving && <CircularProgress size={40} className={classes.fabProgress} />}
          </div>
        </Tooltip>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Archive the {certification.name} certification?</DialogTitle>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this._handleArchive.bind(this, certification, handler)} color="primary" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

      </div >
    );
  }
}
CertificationsTableActions.propTypes = {
  classes: PropTypes.object.isRequired,
};

const MUTATION_MARK_AS_DELETED = gql`
mutation updateCertification($certificationId: ID!){
    updateCertification(certificationId: $certificationId, input:{markedAsDeleted:true}){
    id
  }
}
`;

export default compose(
  graphql(MUTATION_MARK_AS_DELETED, {
    name: 'mutationMarkAsDeleted',
    options: {
      refetchQueries: ["all_certifications_query"]
    }
  }),
  withStyles(styles)
)(CertificationsTableActions);


// WEBPACK FOOTER //
// src/components/innerComponents/CertificationsTableActions.js